import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LiveClassTile } from '../../../live-class-section/class-tile/live-class-tile';
import { LiveClassLessonTrack } from '../../live-class-lesson-track-dto';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-state-locked',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lp2-private-class-left-header-banner [liveClassTile]="liveClassTile" [lessons]="lessons" [track]="track">
      <ng-container withTrack>
        <p class="text-center p-3 m-0 fw-bold fs-6 lh-5 bg-transparent">
          {{ liveClassTile.lockedTextKey | translate }}
        </p>
      </ng-container>
    </lp2-private-class-left-header-banner>
  `,
})
export class PrivateClassStateLockedComponent {
  @Input() track: LiveClassLessonTrack;
  @Input() liveClassTile: LiveClassTile;
  @Input() lessons: Array<PrivateClassLesson>;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-locked.component.ts